// extracted by mini-css-extract-plugin
module.exports = {"link":"NavigationLink_link__3Bzx-","active":"NavigationLink_active__3hgBD","menu_hidden":"NavigationLink_menu_hidden__GDIR7"};